<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle">
      <div class="form-box">
        <div class="form-box-top">
          <img class="image-logo" src="@/assets/images/logo.png" alt="logo" />
          <div class="outer">
            <el-row :gutter="10">
              <img class=" fingerprint" src="@/assets/images/forgetPwd.png" alt="forgetPwd">
            </el-row>
            <div class="success">
              SUCCESS
            </div>
            <br>
            <div class="center">
              We have sent you an email with reset
              <div class="text-center"> instructors</div>
            </div>
            <br>
            <div class="center">
              If the email does not arrive soon,check
              <div class="center">
                your spam folder,it was sent from
              </div>
              <div class="center">
                noreply@eddid.com.hk
              </div>
            </div>

            <div class="text-center">
              <el-button plain size="small" class="reset-btn reset" @click="toLogin">BACK TO LOGIN</el-button>
            </div>
          </div>

          <br>

        </div>
        <div class="form-box-bottom">
          <div class="text-center">

          </div>

          <div class="text-center text-white"><small>© 2017 EDDID.COM</small></div>

          <div class="text-center signin-box pt-20">
            <a class="text-orange">Privacy Policy |</a>
            <a class="text-orange"> Cookies Policy |</a>
            <a class="text-orange"> Terms and Conditions</a>
          </div>
        </div>

      </div>
    </div>
  </vue-scroll>
</template>
<script>
export default {
  name: 'SuccessInfo',
  data () {
    return {}
  },
  methods: {
    toLogin () {
      console.log(111)
      this.$router.replace('/login')
    }
  }
}
</script>
<style lang="scss">
.outer {
  box-shadow: 0px 4px 5px 1px rgba(158, 150, 158, 0.5);
  padding: 40px;
}
.fingerprint {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-bottom: 70px;
}
.success {
  text-align: center;
  font-size: 30px;
  color: #192b57;
}
.center {
  text-align: center;
  color: #192b57;
}
</style>
